import uuid from 'uuid';

type Values = Map<string, any>;
const properties: Values = new Map();
export const addGlobalContext = (values: Values) => {
  for (const [key, value] of values.entries()) {
    properties.set(key, value);
  }
};

export const getSessionId = () => {
  if (!localStorage) {
    return null;
  }

  let sessionId = localStorage.getItem('ordermentum_session_id');
  if (!sessionId) {
    sessionId = uuid.v4() as string;
    localStorage.setItem('ordermentum_session_id', sessionId);
  }

  return sessionId;
};

export const getCampaignData = () => {
  if (!sessionStorage) {
    return {};
  }

  const utmMeta = sessionStorage.getItem('om_utm_meta');

  if (utmMeta) {
    return JSON.parse(utmMeta);
  }

  return {};
};

export const getUserContext = () => ({
  campaign: getCampaignData(),
  sessionId: getSessionId(),
  deviceType: 'desktop',
  operatingSystem: 'web',
  ...Object.fromEntries(properties),
});
